'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import SplideSlider from '@components/SplideSlider';
import Image from 'next/image';
import { ImageObj } from '@custom-types/ImageObj.types';
import WildsLaunchContainer from '../WildsLaunchContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
interface WildsLaunchHarmonyProps {
  harmonyBackgroundImage: any;
  t: any;
  wildHarmonySlide: Array<{ text: string; img: ImageObj; imgMob: ImageObj }>;
}
const wildsLaunchHarmonySettings = {
  type: 'fade',
  rewind: true,
  autoplay: true,
  speed: 1000,
  perMove: 1,
  perPage: 1,
  start: 1,
  drag: false,
  pauseOnHover: false,
};
export default function WildsLaunchHarmony(props: WildsLaunchHarmonyProps) {
  const { t } = props;
  return (
    <Box component="section" className={cn.wildsHarmony}>
      <Box className={cn.wildsHarmonyBackground}>
        <Image
          src={props.harmonyBackgroundImage.url}
          alt="Wilds Launch Harmony - Harmony Background Image"
          width={768}
          height={768}
        />
      </Box>
      <Stack className={cn.wildsHarmonyInner}>
        <WildsLaunchContainer>
          <Box className={cn.wildsHarmonyBlock}>
            <Box className={cn.wildsHarmonyContent}>
              <Box className={cn.wildsHarmonyContent__header}>
                <ParallaxText
                  variant="h2"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['homeHeading'])}
                </ParallaxText>
              </Box>
              <Box className={cn.wildsHarmonyContent__content}>
                <ParallaxText
                  variant="p"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['homeDesc'])}
                </ParallaxText>
              </Box>
            </Box>
            <Box className={cn.harmonyContentGallery}>
              <Mobile>
                <SplideSlider
                  options={wildsLaunchHarmonySettings}
                  className="orientalSlider"
                >
                  {props.wildHarmonySlide.map((slide, index) => (
                    <Box
                      component="picture"
                      key={index}
                      className={cn.harmonyStory}
                    >
                      <div className={cn.harmonyStory__caption}>
                        <ParallaxText
                          variant="h3"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(slide.text)}
                        </ParallaxText>
                      </div>
                      <div className={cn.harmonyStory__image}>
                        <Image
                          src={slide.imgMob.url}
                          alt={`Wilds Launch Harmony - Img Mob ${index + 1}`}
                          layout="responsive"
                          width={600}
                          height={400}
                        />
                      </div>
                    </Box>
                  ))}
                </SplideSlider>
              </Mobile>
              <Desktop>
                <SplideSlider
                  options={wildsLaunchHarmonySettings}
                  className="orientalSlider"
                >
                  {props.wildHarmonySlide.map((slide, index) => (
                    <Box
                      component="picture"
                      key={index}
                      className={cn.harmonyStory}
                    >
                      <div className={cn.harmonyStory__caption}>
                        <ParallaxText
                          variant="h3"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(slide.text)}
                        </ParallaxText>
                      </div>
                      <div className={cn.harmonyStory__image}>
                        <Image
                          src={slide.img.url}
                          alt={`Wilds Launch Harmony - Wild Harmony Slide ${index + 1}`}
                          layout="responsive"
                          width={600}
                          height={400}
                        />
                      </div>
                    </Box>
                  ))}
                </SplideSlider>
              </Desktop>
            </Box>
          </Box>
        </WildsLaunchContainer>
      </Stack>
    </Box>
  );
}
